import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const listStack = lazy(() => import('../../container/pages/stack'));
const addlistStack = lazy(() => import('../../container/pages/addStack'));
const editlistStack = lazy(() => import('../../container/pages/editStack'));

function PagesRoute() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/addlistStack`} component={addlistStack} />
      <Route path={`${path}/editlistStack`} component={editlistStack} />
      <Route path={`${path}/listStack`} component={listStack} />
    </Switch>
  );
}

export default PagesRoute;
